// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var Status;
(function (Status) {
    Status["NOT_SET"] = "NOT_SET";
    Status["UNKNOWN"] = "UNKNOWN";
    Status["GREEN"] = "GREEN";
    Status["RED"] = "RED";
})(Status || (Status = {}));
export var Status_index;
(function (Status_index) {
    Status_index[Status_index["NOT_SET"] = 0] = "NOT_SET";
    Status_index[Status_index["UNKNOWN"] = 1] = "UNKNOWN";
    Status_index[Status_index["GREEN"] = 2] = "GREEN";
    Status_index[Status_index["RED"] = 3] = "RED";
})(Status_index || (Status_index = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PAYMENT_STATUS_UNSPECIFIED"] = "PAYMENT_STATUS_UNSPECIFIED";
    PaymentStatus["PAYMENT_STATUS_PENDING"] = "PAYMENT_STATUS_PENDING";
    PaymentStatus["PAYMENT_STATUS_COMPLETED"] = "PAYMENT_STATUS_COMPLETED";
    PaymentStatus["PAYMENT_STATUS_FAILED"] = "PAYMENT_STATUS_FAILED";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentStatus_index;
(function (PaymentStatus_index) {
    PaymentStatus_index[PaymentStatus_index["PAYMENT_STATUS_UNSPECIFIED"] = 0] = "PAYMENT_STATUS_UNSPECIFIED";
    PaymentStatus_index[PaymentStatus_index["PAYMENT_STATUS_PENDING"] = 1] = "PAYMENT_STATUS_PENDING";
    PaymentStatus_index[PaymentStatus_index["PAYMENT_STATUS_COMPLETED"] = 2] = "PAYMENT_STATUS_COMPLETED";
    PaymentStatus_index[PaymentStatus_index["PAYMENT_STATUS_FAILED"] = 3] = "PAYMENT_STATUS_FAILED";
})(PaymentStatus_index || (PaymentStatus_index = {}));
/**
 *Raw Syncer Pipeline Events for monitoring
 */
export var RawSyncEventType;
(function (RawSyncEventType) {
    RawSyncEventType["SCHEMA"] = "SCHEMA";
    RawSyncEventType["JSONL"] = "JSONL";
    RawSyncEventType["PARQUET"] = "PARQUET";
})(RawSyncEventType || (RawSyncEventType = {}));
export var RawSyncEventType_index;
(function (RawSyncEventType_index) {
    RawSyncEventType_index[RawSyncEventType_index["SCHEMA"] = 0] = "SCHEMA";
    RawSyncEventType_index[RawSyncEventType_index["JSONL"] = 1] = "JSONL";
    RawSyncEventType_index[RawSyncEventType_index["PARQUET"] = 2] = "PARQUET";
})(RawSyncEventType_index || (RawSyncEventType_index = {}));
export const SyncAppMonitoringService = {
    GetSyncAppHealth(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/sync-app-health/location/${req["locationId"]}/source/${req["sourceId"]}?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    GetSyncAppsHealthByLocationId(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/sync-app-health/location/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetWritebackHealthBySourceId(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/sync-app-writeback-health/location/${req["locationId"]}/source/${req["sourceId"]}?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    GetWritebackHealthByLocationId(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/sync-app-writeback-health/location/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetGenericWritebackAttemptsForLocation(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/location/${req["locationId"]}/writebacks?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetSyncAppMetaDataForLocation(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/location/${req["locationId"]}/source-metadata?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetSyncAppMetaData(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["sourceId"], "sourceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/location/${req["locationId"]}/source/${req["sourceId"]}/metadata?${fm.renderURLSearchParams(req, ["locationId", "sourceId"])}`, { method: "GET" });
    },
    GetPaymentWritebackReport(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/syncapp/monitoring/v1/location/${req["locationId"]}/payment-writeback-report?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
};
